import React from "react";
import { useTranslation } from "../../context/TranslationContext";
import { Building2, Factory, Store, Warehouse } from "lucide-react";
import Section from "../ui/Section";
import InfoCard from "../ui/InfoCard";
//Partner Logos
import MagnaLogo from "../../assets/logos/partners/magna.png";
import GoLogo from "../../assets/logos/partners/go.png";
import IlogLogo from "../../assets/logos/partners/ilog.png";
import CWSLogo from "../../assets/logos/partners/cws.svg";
import ZFLogo from "../../assets/logos/partners/zf.svg";
import HadoltLogo from "../../assets/logos/partners/hadolt.png";

const Partners: React.FC = () => {
  const { t } = useTranslation();

  const partners = [
    {
      icon: <Building2 className="w-6 h-6" />,
      title: t("partners.types.manufacturing.title"),
      description: t("partners.types.manufacturing.description"),
    },
    {
      icon: <Factory className="w-6 h-6" />,
      title: t("partners.types.industrial.title"),
      description: t("partners.types.industrial.description"),
    },
    {
      icon: <Store className="w-6 h-6" />,
      title: t("partners.types.retail.title"),
      description: t("partners.types.retail.description"),
    },
    {
      icon: <Warehouse className="w-6 h-6" />,
      title: t("partners.types.logistics.title"),
      description: t("partners.types.logistics.description"),
    },
  ];

  const partnerLogos = [
    {
      name: "Hadolt Transport and Logistics",
      logo: HadoltLogo,
    },
    {
      name: "Go Express",
      logo: GoLogo,
    },
    {
      name: "I-Log Transport and Logistics",
      logo: IlogLogo,
    },
    {
      name: "CWS",
      logo: CWSLogo,
    },
    {
      name: "ZF",
      logo: ZFLogo,
    },
    {
      name: "Magna Steyr",
      logo: MagnaLogo,
    },
  ];

  return (
    <Section id="partners" background="light">
      <div className="text-center mb-12">
        <h2 className="headline mb-6">{t("partners.title")}</h2>
        <p className="section-description mx-auto">
          {t("partners.description")}
        </p>
      </div>
      <div className="flex flex-col md:flex-row gap-20">
        <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-4">
          {partners.map((partner, index) => (
            <InfoCard
              key={index}
              title={partner.title}
              variant="outlined"
              description={partner.description}
            />
          ))}
        </div>

        {/* Partner Logos */}
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {partnerLogos.map((partner, index) => (
            <div key={index} className="rounded-lg text-center">
              <img
                src={partner.logo}
                alt={partner.name}
                className="h-20 mx-auto object-contain"
              />
            </div>
          ))}
        </div>
      </div>
    </Section>
  );
};

export default Partners;
